// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDRFKoBnK1dmfnaQhgsoSTzPt9TGAWgg4c",
  authDomain: "evaluation-tailwind.firebaseapp.com",
  projectId: "evaluation-tailwind",
  storageBucket: "evaluation-tailwind.appspot.com",
  messagingSenderId: "695423148923",
  appId: "1:695423148923:web:8a376da26708e2352153de",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;
